"use strict";
const actionTypes = require('../actionTypes');
const api = require('../api');
const sentryClient_1 = require('../sentryClient');
const snackbarActions = require('./snackbar');
exports.startListeningToAuth = () => (dispatch) => {
    dispatch({ type: actionTypes.ATTEMPT_LOGIN });
    api.auth.onAuthStateChanged((user) => {
        dispatch(user ? exports.loginSuccess(user) : exports.logout());
    });
};
exports.signInWithProvider = (requestedProviderId) => (dispatch) => {
    dispatch({ type: actionTypes.ATTEMPT_LOGIN, requestedProviderId });
    api.auth.signInWithProvider(requestedProviderId).catch(error => {
        if (error instanceof api.AccountExistsError) {
            dispatch(exports.accountExists(error.existingProviderId));
        }
        else if (error instanceof api.UncaughtError) {
            dispatch(exports.cancelLogin());
        }
    });
};
exports.accountExists = (existingProviderId) => ({
    type: actionTypes.ACCOUNT_EXISTS,
    existingProviderId,
});
exports.loginSuccess = (user) => (dispatch) => {
    sentryClient_1.default.setUserContext({
        email: user.email,
        id: user.uid,
    });
    dispatch({
        type: actionTypes.LOGIN_SUCCESS,
        user,
    });
};
exports.cancelLogin = () => (dispatch) => {
    api.auth.cancelLoginAttempt();
    dispatch(snackbarActions.postMessage('Login failed.'));
    dispatch(exports.logout());
};
exports.logout = () => (dispatch) => {
    api.auth.signOut();
    sentryClient_1.default.setUserContext();
    dispatch({ type: actionTypes.LOGOUT });
};



/** WEBPACK FOOTER **
 ** ./src/actions/auth.ts
 **/